























// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import ProvisionTile from './provision-tile.vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { currentUserKey } from '@/shared/msw-constants';

const cssPrefix = 'provision-modal';
@Component({
  components: {
    ProvisionTile,
    ...UUIFComponents,
  },
  directives: {
    tooltip,
  },
})
export default class ProvisionModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  masterMsspRole: boolean = false;
  msspName: string = '';
  selectedMsspObject = {};
  provisionProductMessage = '';

  @Prop()
  msspPrefilterList: SelectOption[];

  @Prop()
  provisionObj: any;

  @Prop()
  mssp:any;

  @Prop()
  tenantOptionsList: SelectOption[];

  onClickProvision(type: string, disabled: boolean) {
    if (!disabled) {
      this.$emit('processProvision', type);
    }
  }

  get getTenantNewModalObject() {
    return this.$store.getters['TenantManagementStoreModule/getNewTenantModalObject'];
  }

  checkForValidation() {
    let flag = false;
    // const tenantModalObject  = this.getTenantNewModalObject;
    if (this.mssp !== '') {
      this.msspPrefilterList.map((ele: any) => {
        if (ele.id === this.mssp && ele.value === 'INACTIVE') {
          flag = true;
        }
      });
    }
    if (flag) {
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: this.$t('tenantMgmt.provision.messages.newMssp') });
      this.$emit('closeProvisionModal');
    }
  }

  checkForMasterMsspRole() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles && userInfoObtained.roles.includes('MASTERMSSP')) {
      return true;
    }
    return false;
  }

  initializeValues() {
    this.masterMsspRole = this.checkForMasterMsspRole();
    const msspFiltered = this.msspPrefilterList.filter((ele: any) => ele.id === this.mssp)[0];
    this.msspName = msspFiltered ? msspFiltered.label.toString() : '';
    this.selectedMsspObject = this.fetchSelectedMsspDetails(this.mssp);
    if (this.tenantOptionsList.length <= 1) {
      this.provisionProductMessage = String(this.$t('tenantMgmt.provision.messages.provsision'));
    } else {
      this.provisionProductMessage = this.provisionObj.provisionProductMsg;
    }
  }

  fetchSelectedMsspDetails(id: string) {
    let msspDetails = {
      MSSPName: '',
      MSSPID: 0,
      Tenants: [],
      isGlobal: '',
    };
    const msspPrefilteredDataFromApi = this.$store.getters['TenantManagementStoreModule/getPreFilter'];
    msspPrefilteredDataFromApi.content.MSSPs && msspPrefilteredDataFromApi.content.MSSPs.map((ele: any) => {
      if (ele.MSSPID === id) {
        msspDetails = Object.assign({}, {
          MSSPName: '',
          MSSPID: 0,
          Tenants: [],
          isGlobal: '',
        });
      }
    });
    return msspDetails;
  }

  created() {
    this.checkForValidation();
    this.initializeValues();
  }
}
